export class EquipmentTempGroup {
    public Id: number;
    public Name: string;
    public BusinessUnitId: number;
    public ProjectId: number;
}
